import React from 'react'
function Dashboard() {
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
               <h1>Safexpay Dashboard</h1>
               <hr />
               <p class="mt-30">Safexpay Dashboard offers a range of features to help you manage your business transactions.
               </p>
               <ul>
                  <li>It includes real-time charts and analytics to gain valuable insights into your business performance.</li>
                  <li>The dashboard displays recent activities that may require your attention.</li>
                  <li>You can configure, operate, and manage your Payment Gateway (PG) account and other products through the dashboard.</li>
                  <li>It provides an overview of recent payments, settlements, and refunds for easy tracking of your transactions.</li>
               </ul>
            </section>
            <section id="idocs_typography" class="mt-60">
               <h2 id="home-page-pg-sec">Home page details</h2>
               <hr/>
               <p class="mt-30">Safexpay Dashboard offers a wide range of features such as analytics and real-time
                  charts that help you gain valuable insight into your business performance. It also has a list
                  of recent activities that may require you to take action.
               </p>
            </section>
            <section id="idocs_content" class="mt-60">
               <h2 id="test-live-pg-sec">Test & live mode</h2>
               <hr />
               <p class="mt-30">
                  Documentation and examples for displaying inline and multiline blocks of code
               </p>
            </section>
            <section id="idocs_content" class="mt-60">
               <h2 id="reports-pg-sec">Reports</h2>
               <hr />
               <p class="mt-30">
                  Documentation and examples for opt-in styling of tables.
               </p>
            </section>
         </div>
         <div class="col-md-4">
         </div>
      </div>
   </div>
</div>
)
}
export default Dashboard